import { tns } from 'tiny-slider/src/tiny-slider';

class ImageGallerySlider {
	constructor(el, prevButton, nextButton, nav) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;

		const isGridSlider = !!this.el.dataset.sliderColumns;

		if (isGridSlider) {
			const userCols = parseInt(this.el.dataset.sliderColumns || '4', 10);
			const colsDesktop = Math.max(1, Math.min(4, userCols));
			const colsTablet = Math.min(colsDesktop, 2);
			const colsMobile = 1;

			this.el.style.setProperty('--ig-cols-desktop', String(colsDesktop));
			this.el.style.setProperty('--ig-cols-tablet', String(colsTablet));

			this.slider = tns({
				container: this.el,
				autoplay: true,
				autoplayButtonOutput: false,
				mouseDrag: true,
				preventScrollOnTouch: 'auto',
				swipeAngle: false,
				speed: 400,
				controls: true,
				prevButton: this.prevButton,
				nextButton: this.nextButton,
				nav: false,
				slideBy: 1,
				items: colsMobile,
				gutter: 40,
				responsive: {
					641: { items: colsTablet },
					1025: { items: colsDesktop }
				}
			});

			return this.slider;
		}

		this.slider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: false,
			gutter: 40,
			autoHeight: true
		});

		return this.slider;
	}
}

export default ImageGallerySlider;